import { useEffect, useRef } from 'react';
import { Post } from '../../../../generated/graphql';
import { communityAnalytics } from '../utils/communityAnalytics';

type Props = {
  postData: {
    author: { id: number };
    media: Post['media'];
    reactions: Post['reactions'];
  };
  influencerId: number;
};

export const useTrackPostViewed = ({ postData, influencerId }: Props) => {
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (hasTrackedRef.current) return;
    hasTrackedRef.current = true;
    communityAnalytics.trackPostViewed(postData, influencerId);
  }, [influencerId, postData]);
};
